import EnrollDetail from './src/main';

/* istanbul ignore next */
EnrollDetail.install = function(Vue) {
  Vue.component(EnrollDetail.name, EnrollDetail);
};

export default EnrollDetail;
